import { render, staticRenderFns } from "./Parcels.vue?vue&type=template&id=7e33ac97&lang=pug&"
import script from "./Parcels.vue?vue&type=script&lang=js&"
export * from "./Parcels.vue?vue&type=script&lang=js&"
import style0 from "./Parcels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports